import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";
import {
  goBack,
  goForward,
  navigationAvailability,
  subscribeNavigationAvailability,
} from "../lib/navigation";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";

export function AppNavigationControls() {
  const [state, setState] = useState(navigationAvailability);
  useEffect(() => subscribeNavigationAvailability(() => setState(navigationAvailability())), []);
  return (
    <nav aria-label="Page history" className="app-history-controls">
      <Tooltip>
        <TooltipTrigger render={<button aria-label="Go back" className="review-header-icon" disabled={!state.back} onClick={goBack} type="button" />}><ChevronLeft aria-hidden="true" /></TooltipTrigger>
        <TooltipContent side="bottom" sideOffset={5}>Back</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger render={<button aria-label="Go forward" className="review-header-icon" disabled={!state.forward} onClick={goForward} type="button" />}><ChevronRight aria-hidden="true" /></TooltipTrigger>
        <TooltipContent side="bottom" sideOffset={5}>Forward</TooltipContent>
      </Tooltip>
    </nav>
  );
}
